import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  Z_INDEXES,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

interface ImageTextlineProps {
  textline: string;
  shouldShowLineOnlyOnHover?: boolean;
  shouldWrap?: boolean;
  upperCase?: boolean;
  dataTestId: string;
}
export const ImageTextline: React.FC<ImageTextlineProps> = ({
  textline,
  shouldShowLineOnlyOnHover = false,
  shouldWrap = true,
  upperCase = false,
  dataTestId,
}) => {
  if (shouldShowLineOnlyOnHover) {
    return (
      <OnHoverAppearingTextline
        data-testid={dataTestId}
        shouldWrap={shouldWrap}
        upperCase={upperCase}
      >
        {textline}
      </OnHoverAppearingTextline>
    );
  }

  return (
    <StyledTextline
      data-testid={dataTestId}
      shouldWrap={shouldWrap}
      upperCase={upperCase}
    >
      {textline}
    </StyledTextline>
  );
};

const StyledTextline = styled.p<{
  shouldWrap: boolean;
  upperCase: boolean;
}>`
  z-index: ${Z_INDEXES.TADARIDA_HEADER_IMG_TEASER_TEXTLINE};
  color: ${COLORS.White};
  display: block;
  font-size: ${FONT_SIZES.px12};
  line-height: ${FONT_SIZES.px12};
  word-break: break-word;
  text-align: center;
  max-width: 90%;
  font-weight: ${FONT_WEIGHTS.bold};
  margin-bottom: 4px;
  text-transform: ${({upperCase}) => (upperCase ? 'uppercase' : 'inherit')};

  white-space: ${props => (props.shouldWrap ? 'normal' : 'nowrap')};
`;

export const OnHoverAppearingTextline = styled(StyledTextline)`
  transition: opacity 0.3s ease;
`;
